import { createReducer, on } from '@ngrx/store';
import { initialProductBasketStore } from './product-basket.store';
import { ProductBasketActions } from './product-basket.actions';

export const productBasketReducer = createReducer(
  initialProductBasketStore,

  // ==================== ADD BASKET PRODUCT ====================
  on(ProductBasketActions.addBasketProduct, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(ProductBasketActions.addBasketProductSuccess, (state, { productBasket }) => ({
    ...state,
    basketProducts: productBasket.basketProducts,
    isPunchOutBasket: productBasket.isPunchOutBasket,
    loading: false,
    error: null
  })),

  on(ProductBasketActions.addBasketProductFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // ==================== UPDATE BASKET PRODUCT QUANTITY ====================
  on(ProductBasketActions.updateBasketProductQuantity, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(ProductBasketActions.updateBasketProductQuantitySuccess, (state, { basketProduct }) => {
    // Backend returns the updated basket product
    const updatedBasketProducts = state.basketProducts.map(bp =>
      bp.id === basketProduct.id ? basketProduct : bp
    );

    return {
      ...state,
      basketProducts: updatedBasketProducts,
      loading: false,
      error: null
    };
  }),

  on(ProductBasketActions.updateBasketProductQuantityFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // ==================== REMOVE BASKET PRODUCT ====================
  on(ProductBasketActions.removeBasketProduct, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(ProductBasketActions.removeBasketProductSuccess, (state, { basketProductId }) => {
    const updatedBasketProducts = state.basketProducts.filter(basketProduct => basketProduct.id !== basketProductId);

    return {
      ...state,
      basketProducts: updatedBasketProducts,
      loading: false,
      error: null
    };
  }),

  on(ProductBasketActions.removeBasketProductFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // ==================== GET SESSION ID BASKET ====================
  on(ProductBasketActions.getSessionIDBasket, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(ProductBasketActions.getSessionIDBasketSuccess, (state, { productBasket }) => ({
    ...state,
    basketProducts: productBasket.basketProducts,
    isPunchOutBasket: productBasket.isPunchOutBasket,
    loading: false,
    error: null
  })),

  on(ProductBasketActions.getSessionIDBasketFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // ==================== PUNCHOUT ====================
  on(ProductBasketActions.getPunchoutFormData, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(ProductBasketActions.getPunchoutFormDataSuccess, (state, { punchOutFormData }) => ({
    ...state,
    loading: false,
    error: null
  })),

  on(ProductBasketActions.getPunchoutFormDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);
